import React from "react";
import Title from "../../ui/Title";

const GenderHealth = () => {
  return (
    <div id="gender-social-determinants-health" className="scroll-mt-24">
      <Title
        title="Gender and social determinants of health"
        className="mb-6"
      />

      <div className="space-y-4 text-softBlack leading-loose text-base font-normal">
        <p>
          The World Health Organization (WHO){" "}
          <a
            href="https://iris.who.int/bitstream/handle/10665/44489/9789241500852_eng.pdf?sequence=1"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue underline"
          >
            defines
          </a>{" "}
          social determinants of health as non-medical factors that affect
          health outcomes. These are the “conditions in which people are born,
          grow, work, live, and age, and the wider set of forces and systems
          shaping the conditions of daily life.” For example, aspects like
          income, education, housing, social inclusion, and more, influence
          health inequalities — that is, the unfair and avoidable differences in
          health status seen within and between countries — positively or
          negatively.
        </p>
        <p>
          Gender is defined as an important social determinant of health in the
          WHO’s{" "}
          <a
            href="https://www.afro.who.int/sites/default/files/2017-06/SDH_conceptual_framework_for_action.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue underline"
          >
            conceptual framework
          </a>{" "}
          for action on the social determinants of health.
        </p>
        <p>
          Gender-based hierarchies in society adversely affect the health
          outcomes of women and girls, as well as men and boys. Women also face
          more adverse effects on health due to gender-based social hierarchies
          when compared to men.
        </p>
        <p>
          According to the WHO, some of the adverse effects on health are
          immediate (for example, gender-based violence), while some adverse
          effects are less visible (like the pattern of under-feeding girls
          compared to their male siblings, contributing to a high rate of
          undernutrition in girls in many societies).
        </p>
        <p>
          The limitations that gender-based discrimination places on women’s
          access to resources also contribute significantly to negative health
          outcomes. For instance, the limitations on the opportunities for women
          and girls to gain education and get well-remunerated jobs with safe
          working conditions, tend to increase health risks. The limitations in
          financial freedom, decision-making power in families, as well as
          gender-biased attitudes, contribute to women and girls facing more
          challenges in accessing quality healthcare.
        </p>
        <p>
          Socially constructed models of masculinity can also adversely affect
          the health of men and boys. For example, increased alcohol
          consumption, substance abuse, and violence can negatively impact
          health outcomes of men and boys.
        </p>
        <p>
          To create better health outcomes, it’s of utmost importance that
          gender disparities are addressed effectively. When we look from the
          lens of caregiving, the unequal load of care that falls on women and
          girls is a further reflection of larger gender-based hierarchies and
          rigid norms in society. Healthcare programs should adopt a gender lens
          while planning the provision of services and also focus on the unequal
          caregiving load on women and girls to create better health outcomes.
        </p>
      </div>
    </div>
  );
};

export default GenderHealth;
